import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Autenticador from './services/autenticator.service';
import { setAuthorization } from './services/authorizationGateway';
import LinkInvalidoComponent from './pages/link-invalido/link-invalido.component';
import HomeComponent from './pages/home/home.component';
import '../src/assets/css/bmg-layout.css';

export default function RootComponent() {
  const [isValidLink, setIsValidLink] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setAuthorization().then().finally(async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const queryValue = queryParams.get("l");
      await ValidaUrl(queryValue?.toString());
      setIsLoading(false);
    });
  }, []);

  const ValidaUrl = async (value: string | undefined) => {
    try {
      if (value) {
        setIsValidLink(await Autenticador.IsValidKey(value));
        localStorage.setItem("k_", value);
      }
    } catch (error) {
      console.log(error);
    }
  }

  if (isLoading)
    return <p>Loading...</p>
  else if (isValidLink)
    return <HomeComponent />
  return <LinkInvalidoComponent />
}

ReactDOM.render(<RootComponent />, document.getElementById("root"));